import { useActionless } from 'app-redux/hooks'

import { SET_ACTIVE_STATE } from 'app-redux/active/actions/types'

import Icon from 'components/elements/Icon'

import styles from './pinnedCards.module.scss'

type Props = {
  className?: string
}

const PinnedCards = ({ className = '' }: Props) => {
  const [setActiveState] = useActionless(SET_ACTIVE_STATE)
  return (
    <div className={`${styles.container} ${className}`}>
      <button className={styles.menu} onClick={() => setActiveState({ pinnedCardsOverlay: true })}>
        <Icon name="pin" />
      </button>
    </div>
  )
}

export default PinnedCards
